export type CompanyTranslationPick = {
  name?: string | null;
  bio?: string | null;
  tags?: string[] | null;
  language?: { code?: string | null } | null;
};

export function pickCompanyTranslation<T extends CompanyTranslationPick>(
  translations: T[] | undefined,
  language?: string | null
): T | undefined {
  if (!translations?.length) return undefined;
  const code = language?.split("-")[0];
  return (
    (code
      ? translations.find((translation) => translation.language?.code === code)
      : undefined) ?? translations[0]
  );
}
